module.exports = __webpack_public_path__ + "img/User.fc692a5c.svg";